@if (toast(); as activeToast) {
  <div
    class="toast-notification"
    [class.success]="activeToast.type === 'success'"
    [class.error]="activeToast.type === 'error'"
    (click)="dismiss()"
    [attr.aria-label]="activeToast.type === 'success' ? 'Success notification' : 'Error notification: ' + activeToast.message + (activeToast.correlationId ? '. Correlation ID: ' + activeToast.correlationId : '')"
  >
    <div class="toast-content">
      <span class="toast-icon">
        @if (activeToast.type === 'success') {
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        } @else {
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        }
      </span>
      <div class="toast-text">
        <span class="toast-message">{{ activeToast.message }}</span>
        @if (activeToast.type === 'error' && activeToast.correlationId) {
          <span class="toast-correlation-id">Correlation ID: {{ activeToast.correlationId }}</span>
        }
      </div>
    </div>
    <button
      class="toast-close-btn"
      (click)="dismiss(); $event.stopPropagation()"
      aria-label="Dismiss notification"
    >×</button>
  </div>
}
